'use strict';

var appRegion = '';
var appNameLower = '';
var appName = '';
var helpIndexPage = '';
var appRegionValueMap = {
  appApiServerHostname: '',
  appApiServerHostnames: []
};
function setAppRegion(value) {
  appRegion = value;
}
function setAppNameLower(value) {
  appNameLower = value;
}
function setAppName(value) {
  appName = value;
}
function getAppRegion() {
  return appRegion;
}
function getAppNameLower() {
  return appNameLower;
}
function getAppName() {
  return appName;
}
function getHelpIndexPage() {
  return helpIndexPage;
}
function setHelpIndexPage(value) {
  helpIndexPage = value;
}
function getAppRegionValue(key) {
  return appRegionValueMap[key];
}
function setAppRegionValue(key, value) {
  appRegionValueMap[key] = value;
}
exports.getAppName = getAppName;
exports.getAppNameLower = getAppNameLower;
exports.getAppRegion = getAppRegion;
exports.getAppRegionValue = getAppRegionValue;
exports.getHelpIndexPage = getHelpIndexPage;
exports.setAppName = setAppName;
exports.setAppNameLower = setAppNameLower;
exports.setAppRegion = setAppRegion;
exports.setAppRegionValue = setAppRegionValue;
exports.setHelpIndexPage = setHelpIndexPage;
